import { generator, getOpacity } from './theme.js';

const opacity = (props) => generator({
    props,
    prop: ['opacity'],
    cssProperty: 'opacity',
    getter: getOpacity,
});

export { opacity };
